<template>
    <div class='edit-component-wrap page-module-wrap'>
        <div class='form-wrap'>
            <div class='name-wrap'>
                <div class='label'>标题</div>
                <div class='input-wrap'><input type="text" class="input" placeholder="请输入标题" v-model='hotMapObj.title'></div>
            </div>
            <div class='status-wrap'>
                <div class='label'>显示状态</div>
                <div class='radio-wrap'>
                    <p class="control">
                        <label class="radio">
                            <input type="radio" :value="0" name='status' v-model='hotMapObj.status'>永久开启
                        </label>
                    </p>
                    <p class="control">
                        <label class="radio">
                            <input type="radio" :value="1" name='status' v-model='hotMapObj.status'>永久关闭
                        </label>
                    </p>
                    <p class="control">
                        <label class="radio">
                            <input type="radio" :value="2" name='status' v-model='hotMapObj.status'>定时开关
                        </label>
                    </p>
                </div>
                <div class='datetime-wrap' v-show="hotMapObj.status == 2">
                    <el-date-picker v-model="hotMapObj.timeRange" type="datetimerange" placeholder="选择时间范围"></el-date-picker>
                </div>
            </div>
            <div class="clearfix">
                <input type="checkbox" value="1" v-model="hotMapObj.showUserStatus">未付费用户可见
                <input type="checkbox" value="2" v-model="hotMapObj.showUserStatus">其他用户可见
            </div>
            <div class='hot-map-wrap'>
                <div class='label'>添加图片热区</div>
                <div class="button-wrap">
                    <span class="button is-primary" id="js_hotImageUploadBtn">上传图片</span>
                    <span><span class='red'>【分类】建议尺寸：326*160px</span> 只能上传 jpg/png 文件，且不超过 1MB</span>
                </div>
                <div class="img-wrap" id='hotShotImg' style='width:800px'>
                    <image-component :image="hotImage.image" :width='800'></image-component>
                    <div v-if="index !== hotMapIndex" class="rect" v-for="(item, index) in hotMaps" :style="getStyle(item.rect)"></div>
                </div>
                <div class='table-wrap' v-show='hotImage.image'>
                    <table class='table is-bordered'>
                        <thead><tr><td>选中</td><td>名称</td><td>链接</td><td>位置</td><td>删除</td></tr></thead>
                        <tbody>
                        <tr v-for='(hotMap,index) in hotMaps'>
                            <td><div class='radio-wrap'><input type="radio" name='hotMap' :value='index' v-model='hotMapIndex' @click='hotMapRadioClick(index)'></div></td>
                            <td><input class='input' type="text" v-model='hotMap.title'></td>
                            <td>
                                <custom-link :link='hotMap.link' @update:link="val => { hotMap.link = val }"></custom-link>
                            </td>
                            <td>{{Object2String(hotMap.rect)}}</td>
                            <td><button class='button is-danger' @click='deleteHotMapItem(index)'>删除</button></td>
                        </tr>
                        </tbody>
                    </table>
                    <div class='clearfix'><button class="button is-primary fright margin-right-10" @click='addHotMap'>添加热点</button></div>
                </div>
            </div>
        </div>
        <div class='foot'>
            <button class='button is-primary' @click='doSave'>保存</button>
            <button class='button' @click='backClick'>返回</button>
        </div>

    </div>
</template>

<script type="text/babel">
import Uploader from 'COMMON/uploaderModule/uploader'
import $ from 'expose-loader?$!jquery'
import 'COMMON/imgAreaSelect/imgareaselect-default.css'
import 'COMMON/imgAreaSelect/jquery.imgareaselect.js'
import { formatDate } from 'UTILS/date'
import CustomLink from 'COMMON/DefinedLink'

export default {
  data () {
    return {
      hotMapObj: {
        title: '',
        status: 0,
        timeRange: [],
        showUserStatus: [1, 2]
      },
      hotImage: {
        image: '',
        width: '',
        height: ''
      },
      hotMaps: [
        {
          linkId: 0,
          rect: {},
          link: '',
          title: ''
        }
      ],
      hotMapIndex: 0,
      imgSelect: null,
      modal: {
        title: '编辑自定义链接',
        visible: false,
        link: ''
      },
      boxList: []
    }
  },
  mounted () {
    this.getModuleContent()
    this.uploadMainBind()
  },
  components: { CustomLink },
  computed: {
    currentWidth () {
      return 800
    },
    currentHeight () {
      return this.hotImage.height * (800 / this.hotImage.width)
    }

  },
  methods: {
    getStyle (box) {
      let positionStyle = this.getPositionStyle(box)

      return Object.assign({}, positionStyle)
    },
    getPositionStyle (box) {
      let _width = box.width
      let _height = box.height
      let _x = box.x1
      let _y = box.y1
      return {
        top: _y + 'px',
        left: _x + 'px',
        width: _width + 'px',
        height: _height + 'px'
      }
    },
    getModuleContent () {
      if (this.$route.query.advId) {
        let params = {
          advId: this.$route.query.advId
        }
        HttpRequest.get('/admin.php?method=advertisementofmine.getAdvertisementofmine', params).then((response) => {
          this.hotMapObj.title = response.data.title

          if (response.data.status == 0 && (response.data.endTime != 1917014400)) {
            this.hotMapObj.status = 2
            this.hotMapObj.timeRange.push(formatDate(response.data.startTime, 'yyyy-MM-dd hh:mm:ss'))
            this.hotMapObj.timeRange.push(formatDate(response.data.endTime, 'yyyy-MM-dd hh:mm:ss'))
          } else {
            this.hotMapObj.status = response.data.status
          }
          if (!response.data.showUserStatus || response.data.showUserStatus.length == 0) {
            this.hotMapObj.showUserStatus = [1, 2]
          } else {
            this.hotMapObj.showUserStatus = response.data.showUserStatus
          }
          this.hotImage = response.data.subDataImage.image ? response.data.subDataImage.image : this.hotImage
          this.hotMaps = response.data.subDataImage.hotZone

          this.hotMaps.forEach((item) => {
            let value = item.rect
            value.x1 = this.formatToMap(value.x1, this.currentWidth)
            value.x2 = this.formatToMap(value.x2, this.currentWidth)

            value.y1 = this.formatToMap(value.y1, this.currentHeight)
            value.y2 = this.formatToMap(value.y2, this.currentHeight)
            value.width = this.formatToMap(value.width, this.currentWidth)
            value.height = this.formatToMap(value.height, this.currentHeight)
          })
          if (this.hotMaps.length) {
            this.bindImageSelect(this.hotMaps[0].rect)
          }
        })
      }
    },
    hotMapRadioClick (index) {
      this.hotMapIndex = index
      if (this.hotMaps[index] && this.hotMaps[index].rect) {
        this.bindImageSelect(this.hotMaps[index].rect)
      } else {
        this.bindImageSelect()
      }
    },
    addHotMap () {
      this.hotMaps.push({linkId: 0, rect: {'x1': 0, 'x2': 100, 'y1': 0, 'y2': 100, 'width': 100, 'height': 100}, link: ''})
      if (this.hotMaps.length == 1) {
        this.hotMapIndex == 0
      } else {
        this.hotMapIndex = this.hotMaps.length - 1
      }
      this.hotMapRadioClick(this.hotMapIndex)
    },
    deleteHotMapItem (index) {
      this.hotMaps.splice(index, 1)
      if (index > 0) {
        --this.hotMapIndex
      }
      this.hotMapRadioClick(this.hotMapIndex)
    },
    doSave () {
      let hotMapObj = {
        title: this.hotMapObj.title,
        status: this.hotMapObj.status,
        showUserStatus: this.hotMapObj.showUserStatus
      }
      if (!hotMapObj.title) {
        this.$message('请填写标题')
        return
      }
      if (this.hotMapObj.status == 2) {
        hotMapObj.status = 0
        if (this.hotMapObj.timeRange[0]) {
          hotMapObj.startTime = this.hotMapObj.timeRange[0]
          hotMapObj.endTime = this.hotMapObj.timeRange[1]
        } else {
          this.$message('请选择时间范围')
          return
        }
      } else {
        hotMapObj.startTime = ''
        hotMapObj.endTime = ''
      }

      this.hotMaps.forEach((item) => {
        let value = item.rect
        value.x1 = this.formatByMap(value.x1, this.currentWidth)
        value.x2 = this.formatByMap(value.x2, this.currentWidth)

        value.y1 = this.formatByMap(value.y1, this.currentHeight)
        value.y2 = this.formatByMap(value.y2, this.currentHeight) < 100 ? this.formatByMap(value.y2, this.currentHeight) : 100
        value.width = this.formatByMap(value.width, this.currentWidth)
        value.height = this.formatByMap(value.height, this.currentHeight)
      })

      let subDataImage = {image: this.hotImage, hotZone: this.hotMaps}

      let params = Object.assign({subDataImage: subDataImage}, hotMapObj, {image: this.hotImage})

      if (this.$route.query.advId) {
        params.advId = this.$route.query.advId
      }
      HttpRequest.post('/admin.php?method=advertisementofmine.doSaveAdvertisementofmine', params).then((response) => {
        if (response.data.result) {
          this.$message('保存成功')
          setTimeout(() => {
            this.$router.push({
              name: 'hotAd',
              query: {
                page: this.$route.query.page
              }
            })
          }, 1000)
        }
      })
    },
    formatByMap (value, format) {
      return (value * (100 / format)).toFixed(2)
    },
    formatToMap (value, format) {
      return (value / (100 / format)).toFixed(2)
    },
    backClick () {
      this.$router.push({
        name: 'hotAd',
        query: {
          page: this.$route.query.page
        }
      })
    },
    initImageSelect () {
      this.imgSelect && this.imgSelect.setOptions({ hide: true })
      this.hotMapIndex = 0
    },
    Object2String (obj) {
      return JSON.stringify({x1: obj.x1, x2: obj.x2, y1: obj.y1, y2: obj.y2, width: obj.width, height: obj.height})
    },
    uploadMainBind () {
      // 绑定上传图片控件
      let params = {
        config: {
          pick: {
            id: '#js_hotImageUploadBtn',
            multiple: false
          },
          server: process.env.VUE_APP_PLATFORM + '/admin.php?method=image.uploadImage',
          fileVal: 'image'
        },
        extensionField: {
          target: this
        },
        events: {
          onFilesQueued (files, uploaderObj) {
            return this.onFilesQueued && this.onFilesQueued(files, uploaderObj)
          },
          onSuccess (response, file, uploaderObj) {
            this.hotImage.image = response.data.images.info.path
            this.hotImage.width = response.data.images.info.width
            this.hotImage.height = response.data.images.info.height
            this.initImageSelect()
            this.bindImageSelect(this.hotMaps[this.hotMapIndex].rect)
          },
          onError (response, file, uploaderObj) {

          }
        }
      }
      new Uploader(params)
    },
    bindImageSelect (data = {}) {
      if (!(Object.keys(data).length)) {
        data = {x1: 0, y1: 0, x2: 100, y2: 100, width: 100, height: 100}
        if (this.hotMaps[0]) {
          this.hotMaps[0].rect = {'x1': 0, 'x2': 100, 'y1': 0, 'y2': 100, 'width': 100, 'height': 100}
        }
      }
      let that = this
      let obj = {
        handles: true,
        onSelectEnd (img, selection) {
          if (selection.width > 0 && selection.height > 0) {
            that.hotMaps[that.hotMapIndex].rect = selection
          }
        }
      }
      this.$nextTick(() => {
        setTimeout(() => {
          this.imgSelect = $('#hotShotImg img').imgAreaSelect(Object.assign(data, obj, {instance: true}))
          this.imgSelect.setOptions({resizable: true})
        }, 500)
      })
    }

  },
  destroyed () {
    this.imgSelect && this.imgSelect.remove()
  }
}
</script>

<style lang="less" scoped>
    .hot-map-wrap{
        .img-wrap{
            position: relative;
        }
    }
    .rect {
        position: absolute;
        color:#fff;
        font-size: 18px;
        border: 3px dashed #333;
    }
    .input-wrap {
        margin: 10px 0;

        input {
            height: 32px;
            width: 100%;
            text-indent: 10px;
        }
    }
    .radio-wrap {
        margin: 10px 0 0;
    }
    .datetime-wrap {
        margin-bottom: 10px;
    }
    .upload-wrap {
        margin: 10px 0;
    }
    .button-wrap {
        margin: 10px 0;
        line-height: 32px;

        .img-wrap {
            margin: 10px 0;
        }
    }
    .status-wrap {
        height: 110px;
    }
    .table-wrap {
        .radio-wrap {
            text-align: center;
        }
    }
    .form-wrap {
        border: 1px solid #ccc;
        padding: 15px;
    }
    .foot {
        margin: 20px 0 50px;
        text-align: center;
    }
    .margin-right-10 {
        margin-right: 10px;
    }
    .modal-wrap {
        min-height: 150px;
    }

</style>
